import { useCallback } from 'react';

declare global {
  interface Window {
    Intercom: any;
  }
}

export const useIntercom = () => {
  const show = useCallback(() => {
    if (window.Intercom) {
      try {
        window.Intercom('show');
      } catch {
        // fallback: open with boot if not initialized yet
        window.Intercom('boot');
        window.Intercom('show');
      }
    }
  }, []);

  const hide = useCallback(() => {
    if (window.Intercom) {
      window.Intercom('hide');
    }
  }, []);

  const showMessages = useCallback(() => {
    if (window.Intercom) {
      window.Intercom('showMessages');
    }
  }, []);

  const showNewMessage = useCallback((message?: string) => {
    if (window.Intercom) {
      if (message) {
        window.Intercom('showNewMessage', message);
      } else {
        window.Intercom('showNewMessage');
      }
    }
  }, []);

  const update = useCallback((data: any) => {
    if (window.Intercom) {
      window.Intercom('update', data);
    }
  }, []);

  const trackEvent = useCallback((eventName: string, metadata?: any) => {
    if (window.Intercom) {
      window.Intercom('trackEvent', eventName, metadata);
    }
  }, []);

  const isAvailable = useCallback(() => {
    return !!window.Intercom;
  }, []);

  return {
    show,
    hide,
    showMessages,
    showNewMessage,
    update,
    trackEvent,
    isAvailable,
  };
};
